import { Component, PLATFORM_ID, Signal, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/partials/header/header.component';
import { FooterComponent } from './shared/partials/footer/footer.component';
import { AsyncPipe, CommonModule, isPlatformBrowser } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Store } from '@ngrx/store';
import { getCities, getDestinations } from './reducers/redux/actions';
import { selectCurrentCities } from './reducers/redux/selectors/cities.selectors';
import { selectCurrentDestinations } from './reducers/redux/selectors/destinations.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, startWith } from 'rxjs/operators';
import {
  getAllBlogCategories,
  getAllFooterLinks,
  getAllHeroBanners,
  getAllMegaMenu,
  getAllPackageThemes,
  getAllPress,
  getAllQuickLinks,
  getAllSiteSettings,
  getPackageCategory,
  getTravellerStories,
} from './components/home/redux/actions';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { BottomPopupBannerComponent } from "./components/bottom-popup-banner/bottom-popup-banner.component";
import { CartStore } from './components/booking/cart.store';
import { bookingService } from './components/booking/booking.service';
import { JsonLdService } from './components/services/json-ld.service';
import { SmallHeaderComponent } from './shared/partials/small-header/small-header.component';

const MaterialModules = [MatButtonModule];

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, FooterComponent, ...MaterialModules, BottomPopupBannerComponent, SmallHeaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'TripXL Holidays';
  isCollapsed = true;
  packages: any[] = [];

  private store = inject(Store);
  private platformId = inject(PLATFORM_ID); // Use the inject function to get the store
  private cartStore = inject(CartStore);
  private bookingService = inject(bookingService);
  private router = inject(Router);
  get isBlogRoute(): boolean {
    return /^\/blog(?:[/?#]|$)/.test(this.router.url);
  }
  private jsonLd = inject(JsonLdService)
  
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          document.body.style.overflow = 'auto';
          document.body.style.position = '';
        }
      });

      this.cartStore.hydrateFromStorage();

      this.bookingService.getCart().subscribe({
        next: cart => this.cartStore.setCart(cart),
        error: () => this.cartStore.clear(),
      });
    }
      this.setupOrganizationJsonLd();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.store.dispatch(getAllHeroBanners());
      this.store.dispatch(getAllSiteSettings());
      this.store.dispatch(getPackageCategory());
      this.store.dispatch(getAllPackageThemes());
      this.store.dispatch(getAllPress());
      this.store.dispatch(getAllBlogCategories());
      // this.store.dispatch(getTravellerStories());
      this.store.dispatch(
        getTravellerStories({
          data: { isDomestic: true }, // Replace with actual value if dynamic
          minimal: false,
        })
      );
      this.store.dispatch(getAllFooterLinks());
      this.store.dispatch(getAllQuickLinks());
      this.store.dispatch(getCities({ category: 'all' }));
      this.store.dispatch(
        getDestinations({ queryParams: { showCanonicals: false } })
      );
    }
  }
  trackByFn(index: number, item: any): any {
    return item.id; // Use a generic item to handle both cities and destinations
  }


   setupOrganizationJsonLd(): void {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Hospitality",
      "name": "UDAAN HOTELS & RESORTS",
      "url": "https://udaan.tripxl.com/",
      "logo": "	https://i0.wp.com/udaanhotels.com/wp-content/uploads/2021/10/cropped-Asset-1@2x.png?w=480&ssl=1",
      "telephone": "+919555033033",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Siliguri",
        "addressCountry": "IN"
      },
      "sameAs": [
        "https://www.facebook.com/udaanhotels",
        "https://www.instagram.com/udaanhotels/",
        "https://www.linkedin.com/company/udnhtls/",
        "https://www.youtube.com/@udaanhotels"
      ],
      "foundingDate": "2024",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+919555033033",
          "contactType": "customer support",
          "areaServed": "IN"
        }
      ]
    };

    // stable id => no duplicates
    this.jsonLd.setJsonLd('org-travel-agency', schema);
  }
}
